import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { CollectionPointWithI18nKey } from '../../../../types/collectionPoints';
import { getAssetUrl } from '../../../../utils/config';
import { ViewOption } from '../Overview/ViewOptions';
import LocationInformation from './LocationInformation';
import './style.scss';

type LocationDetailsProps = {
  location: CollectionPointWithI18nKey;
  view: ViewOption;
  onBackButtonClick: () => void;
  isDisabled?: boolean;
};

const LocationDetails = ({ location, view, onBackButtonClick, isDisabled }: LocationDetailsProps) => (
  <>
    <div
      className={classNames('location-details__back-button', { 'cursor-disabled': isDisabled })}
      onClick={() => !isDisabled && onBackButtonClick()}
      data-test-id="location-details-back-button"
    >
      <img src={getAssetUrl('collectionPoints/chevronLeft.svg')} alt="left" />
      <p>
        <FormattedMessage
          id="shipping.collectionPoint.back"
          values={{ view: <FormattedMessage id={`shipping.collectionPoint.views.${view}`} /> }}
        />
      </p>
    </div>
    <LocationInformation location={location} />
  </>
);

export default LocationDetails;
